// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PartnerScoreRepoConfig from "./PartnerScoreRepoConfig.bs.js";

var dummyPartnerScoreResponse = [
    {
        "scoreName": "COMPLETION_SCORE",
        "scoreState": "UNLOCKED",
        "scoreValue": 79.5,
        "scoreThresholds": [
            40,
            90
        ],
        "scoreActionValues": [],
        "actionText": "",
        "actionThreshold": null,
        "actionState": "SAFE"
    },
    {
        "scoreName": "CANCELLATION_SCORE",
        "scoreState": "UNLOCKED",
        "scoreValue": 2.12,
        "scoreThresholds": [
            4,
            8,
            12,
            20
        ],
        "scoreActionValues": [
            "5",
            "10",
            "24",
            "PERMANENT"
        ],
        "actionText": "Well done! Continue maintaining cancellation score below 4 to avoid any action.",
        "actionThreshold": null,
        "actionState": "SAFE"
    },
     {
        "scoreName": "CANCELLATION_SCORE",
        "scoreState": "UNLOCKED",
        "scoreValue": 9.05,
        "scoreThresholds": [
            4,
            8,
            12,
            20
        ],
        "scoreActionValues": [
            "5",
            "10",
            "24",
            "PERMANENT"
        ],
        "actionText": "Well done! Continue maintaining cancellation score below 4 to avoid any action.",
        "actionThreshold": null,
        "actionState": "APPLIED"
    },
    {
        "scoreName": "CANCELLATION_SCORE",
        "scoreState": "UNLOCKED",
        "scoreValue": 45.33,
        "scoreThresholds": [
            4,
            8,
            12,
            20
        ],
        "scoreActionValues": [
            "5",
            "10",
            "24",
            "PERMANENT"
        ],
        "actionText": "Well done! Continue maintaining cancellation score below 4 to avoid any action.",
        "actionThreshold": null,
        "actionState": "APPLIED"
    },
    {
        "scoreName": "CANCELLATION_SCORE",
        "scoreState": "LOCKED",
        "scoreValue": 9.9,
        "scoreThresholds": [
            4,
            8,
            12,
            20
        ],
        "scoreActionValues": [
            "5",
            "10",
            "24",
            "PERMANENT"
        ],
        "actionText": "Well done! Continue maintaining cancellation score below 4 to avoid any action.",
        "actionThreshold": null,
        "actionState": "APPLIED"
    },
    {
        "scoreName": "OVERALL_SCORE",
        "scoreState": "LOCKED",
        "scoreValue": 88.8,
        "scoreThresholds": [
            50,
            90
        ],
        "scoreActionValues": [],
        "actionText": "",
        "actionThreshold": null,
        "actionState": "SAFE"
    }
];

function fetchPartnerScore(msisdn, auth_token) {
  Logger$Catalyst.trace({
        requestUrl: "fetchPartnerScoreApiCalled"
      });
  Logger$Catalyst.debug({
        payload: msisdn
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyPartnerScoreResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerScoreRepoConfig.PartnerScoreResponseConverter.execute, result);
                            });
                }), "");
}

var DummyPartnerScoreRepo = {
  dummyPartnerScoreResponse: dummyPartnerScoreResponse,
  fetchPartnerScore: fetchPartnerScore
};

export {
  DummyPartnerScoreRepo ,
  
}
/* NetworkUtils Not a pure module */
